import { DateStr } from "~/app/core/model/date-str";
import { AddressInfo } from "~/app/core/model/address-info";
import { WeeklyHours } from "~/app/core/model/weekly-hours";
import { OfferTag } from "~/app/core/model/offer-tag";
import { DescriptionBlob } from "~/app/core/model/description-blob";
import { FormattedString } from "~/app/core/model/formatted-string";

export class OfferInfo {
    variant?: number = 2;
    id: number;
    sortPriority?: number;
    free: boolean;
    bounceback: boolean;
    revealed: boolean; // whether or not to show the obscured view of the offer
    revealCost: number; // how many tickets it costs to reveal the offer
    favorite: boolean; // whether or not the offer has been added to the user's personal coupon list
    favoriteCost: number; // how many tickets it costs to reveal the offer
    repeatUnlocked: boolean; // whether or not the offer has been re-unlocked for repeat redeem
    repeatUnlockCost: number; // how many tickets it costs to re-unlock the offer
    sample: boolean;
    startDate?: DateStr;
    name: string;
    terms: string;
    additionalTerms?: FormattedString;
    whatElseDescription?: DescriptionBlob;
    weeklyHours?: WeeklyHours;
    imageBannerText?: string;
    dollarValue?: number;
    nextAvailableDate?: DateStr;
    expirationDate: DateStr;
    nearbyDate?: DateStr;
    watchedVideo?: DateStr;
    redeemedDate?: DateStr;
    bouncebackDate?: DateStr;
    notifiedDate?: DateStr;
    seenDate?: DateStr;
    lastSeenDate?: DateStr;
    unseenUntilDate?: DateStr;
    imageUrl: string;
    imageHash?: string;
    companyId: number;
    companyName: string;
    companyDescription?: FormattedString;
    companyLogoUrl: string;
    companyLogoHash?: string;
    companyWebUrl: string;
    reviewUrl: string;
    addresses: Array<AddressInfo>;
    onlineOnly?: boolean;
    shipping?: "none"|"free"|"additional";
    onlineRedeemUrl?: string;

    bounceBackOfferId?: number;
    thumbsDate?: DateStr;
    thumbs?: "up"|"down"|"skip";
    bouncedDate?: DateStr;

    purchaseSurveyAnswer?: "yes"|"no";
    purchaseSurveyDate?: DateStr;

    category?: Array<string>;
    tags?: Array<OfferTag>
    filterText?: string;

    static migrate(o: any): OfferInfo {
        if (!o.variant) o.variant = 1;
        OfferInfo.migrate1(o);
        return o as OfferInfo;
    }

    private static migrate1(o: any) {
        if (o.variant === 1) {
            o.addresses = [];
            o.addresses.push({
                street1: o.addressStreet,
                city: o.addressCity,
                state: o.addressState,
                zip: o.addressZip,
                phone: o.companyPhone,
                latitude: o.longitude,
                longitude: o.latitude
            });
            delete o.addressStreet;
            delete o.addressCity;
            delete o.addressState;
            delete o.addressZip;
            delete o.companyPhone;
            delete o.longitude;
            delete o.latitude;
        }
    }
}
